import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Common
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { BlockIcon } from '$common/icons/block'
import { RemoveChatIcon } from '$common/icons/remove-chat'
import { ClearHistoryIcon } from '$common/icons/clear-history'
import { AddUserIcon, EditOutlinedIcon } from '$common/icons'
import { ReportIcon } from '$common/icons/report'
import { RemoveIcon } from '$common/icons/remove'
// Localization
import { useAsyncFunction } from '$func/async-function.react-hook'
import { getPvByUserId } from '$logic/pv'
import { useUser } from '$logic/users'
import { t } from '$i18n'
import { blockUser, unBlockUser } from '$logic/user-policy'
import { openEditContact } from '$logic/router'
import {
  showClearPVHistory,
  showDeleteContactModal,
  showDeletePvModal,
} from '$comp/modals/confirmation-dialog'
import { showReportSendSnackbar } from '$comp/snackbars'

interface Props {
  userId: string
  isOpen: boolean
}
export function ChatWithUserMenu({ userId, isOpen }: Props) {
  const { user } = useUser(userId)
  const isContact = user?.isContact
  const isBLocked = user?.isBlocked
  const isDeleted = user?.deletedAt

  const onBlock = async () => {
    analite('BLOCK_USER', {
      active: true,
      source: 'USER_MENU',
    })
    await blockUser(userId)
    await closeCurrentModal()
  }
  const onUnBlock = async () => {
    analite('BLOCK_USER', { active: false, source: 'USER_MENU' })
    await unBlockUser(userId)
    await closeCurrentModal()
  }
  const onReport = async () => {
    await closeCurrentModal()
    showReportSendSnackbar()
    // TODO: Show report modal
  }

  const onAddToContacts = async () => {
    await closeCurrentModal()
    openEditContact(userId, true)
  }
  const onEditContact = async () => {
    await closeCurrentModal()
    openEditContact(userId)
  }
  const onDeleteContact = async () => {
    await closeCurrentModal()
    showDeleteContactModal(userId)
  }
  const onRemoveChat = async () => {
    await closeCurrentModal()
    showDeletePvModal(userId)
  }
  const onClearHistory = async () => {
    await closeCurrentModal()
    showClearPVHistory(userId)
  }

  const { value: hasPv } = useAsyncFunction(
    () => getPvByUserId(userId),
    [userId],
  )

  return (
    <PopupMenuList open={isOpen}>
      {!isBLocked ? (
        <PopupMenuItem text={t('profile.user.block')} onClick={onBlock}>
          <BlockIcon sx={{ color: 'secondary.main' }} />
        </PopupMenuItem>
      ) : (
        <PopupMenuItem text={t('profile.user.unblock')} onClick={onUnBlock}>
          <BlockIcon sx={{ color: 'secondary.main' }} />
        </PopupMenuItem>
      )}

      <PopupMenuItem text={t('menu.common.report')} onClick={onReport}>
        <ReportIcon />
      </PopupMenuItem>

      {isContact && (
        <PopupMenuItem text={t('contacts.editContact')} onClick={onEditContact}>
          <EditOutlinedIcon sx={{ color: 'secondary.main' }} />
        </PopupMenuItem>
      )}
      {isContact && (
        <PopupMenuItem
          text={t('profile.user.deleteContact')}
          onClick={onDeleteContact}
        >
          <RemoveIcon />
        </PopupMenuItem>
      )}
      {!isContact && !isDeleted && user?.phone && (
        <PopupMenuItem
          text={t('profile.user.addToContacts')}
          onClick={onAddToContacts}
        >
          <AddUserIcon color="secondary" />
        </PopupMenuItem>
      )}

      {hasPv && (
        <PopupMenuItem
          text={t('menu.common.removeChat')}
          onClick={onRemoveChat}
        >
          <RemoveChatIcon />
        </PopupMenuItem>
      )}

      {hasPv && (
        <PopupMenuItem
          text={t('menu.common.clearHistory')}
          onClick={onClearHistory}
        >
          <ClearHistoryIcon />
        </PopupMenuItem>
      )}
    </PopupMenuList>
  )
}
